import React from 'react';

// T0 — Onglets contrôlés. `tabs` = [{id,label,count?}] ou string[]. `active`/`onChange` pilotés par le parent.
export const Tabs = ({ tabs = [], active, onChange, className = '' }) => (
  <div className={`flex gap-1 border-b border-gray-200 dark:border-gray-700 overflow-x-auto ${className}`}>
    {tabs.map((t) => {
      const id = t.id ?? t;
      const label = t.label ?? t;
      const isActive = id === active;
      return (
        <button
          key={id}
          type="button"
          onClick={() => onChange && onChange(id)}
          className={`px-4 py-2 text-sm font-medium border-b-2 -mb-px whitespace-nowrap transition-colors ${
            isActive
              ? 'border-blue-500 text-blue-600 dark:text-blue-400'
              : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200'
          }`}
        >
          {label}
          {t.count != null && <span className="ml-1 text-xs opacity-70">({t.count})</span>}
        </button>
      );
    })}
  </div>
);

export default Tabs;
